// Acceso al catálogo de tipos de llamada. El listado por color se pide al
// backend en cada pulsación ANDON en vez de filtrar el catálogo completo en
// memoria: el backend ya devuelve los registros no borrados y ordenados por
// `Orden`, así que la lista NO debe reordenarse aquí.
const API = process.env.REACT_APP_SERVICE_ENDPOINT_NE;
const FETCH_TIMEOUT_MS = 15000;

const ERROR_MESSAGES = {
    401: 'Tu sesión ha expirado. Vuelve a iniciar sesión.',
    403: 'No tienes permiso para consultar los tipos de llamada.',
    500: 'Error interno del servidor. Intenta de nuevo más tarde.',
};

export class TiposLlamadaApiError extends Error {
    constructor(message, status) {
        super(message);
        this.name = 'TiposLlamadaApiError';
        this.status = status;
    }
}

// `color`: 1 Verde, 2 Rojo, 3 Amarillo, 4 Azul (catálogo ColoresLlamada).
// Un color sin tipos configurados responde 200 [] — nunca 404.
// `signal` (opcional): permite cancelar la petición cuando se pulsa otro
// color antes de que esta responda; un abort externo se propaga tal cual
// para que el llamador lo distinga de un error real.
export async function getTiposLlamadaPorColor(color, token, signal) {
    if (!token) {
        throw new TiposLlamadaApiError('Sin sesión activa. Vuelve a iniciar sesión.', 401);
    }

    const controller = new AbortController();
    const timeoutId = setTimeout(() => controller.abort(), FETCH_TIMEOUT_MS);
    const onExternalAbort = () => controller.abort();
    if (signal) signal.addEventListener('abort', onExternalAbort);

    try {
        const res = await fetch(
            `${API}/tiposllamada/ListadoPorColor?color=${encodeURIComponent(color)}`,
            {
                method: 'GET',
                signal: controller.signal,
                headers: {
                    authorization: `Bearer ${token}`,
                    Accept: 'application/json',
                    'Content-Type': 'application/json',
                },
            }
        );
        if (!res.ok) {
            throw new TiposLlamadaApiError(
                ERROR_MESSAGES[res.status] || 'No se pudieron cargar los tipos de llamada.',
                res.status
            );
        }
        const data = await res.json();
        return Array.isArray(data) ? data : [];
    } catch (error) {
        if (error instanceof TiposLlamadaApiError) throw error;
        // Aborto externo (se pulsó otro color): se propaga tal cual para que
        // el llamador lo descarte sin mostrarlo como error.
        if (error.name === 'AbortError' && signal && signal.aborted) throw error;
        if (error.name === 'AbortError') {
            throw new TiposLlamadaApiError(
                'El servidor no respondió. Verifica tu conexión e intenta de nuevo.',
                0
            );
        }
        throw new TiposLlamadaApiError('Error de red al cargar los tipos de llamada.', 0);
    } finally {
        clearTimeout(timeoutId);
        if (signal) signal.removeEventListener('abort', onExternalAbort);
    }
}
